'use strict';

var _ = require('lodash');
var ModelToPayloadTransformerServiceAAA = function ModelToPayloadTransformerServiceAAA(StrategyAction, StrategyCondition, strategyConstants) {
  var ALLOCATION_AUTH_AVAIL = strategyConstants.ALLOCATION_AUTH_AVAIL;
  function transform(strategy, strategyConditions) {
    var groups = [];
    strategy.actionList.forEach(function (action) {
      if (isValidValue(action.className) || isValidValue(action.allocationType) || isValidValue(action.minAllocation) || isValidValue(action.maxAllocation) || isValidValue(action.hardOverrideMinValue) || isValidValue(action.hardOverrideMaxValue) || isValidValue(action.authLinkValue) || isValidValue(action.linkValue) || isValidValue(action.minAvailability) || isValidValue(action.maxAvailability)) {
        var actions = [];
        var conditions = [];
        if (isValidValue(action.allocationType) && action.allocationType != '...') {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'allocationType',
            value: action.allocationType
          }));
        }
        if (isValidValue(action.minAllocation)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'minAllocation',
            value: action.minAllocation
          }));
        }
        if (isValidValue(action.maxAllocation)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'maxAllocation',
            value: action.maxAllocation
          }));
        }
        if (isValidValue(action.hardOverrideMinValue)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'hardOverrideMinValue',
            value: action.hardOverrideMinValue
          }));
        }
        if (isValidValue(action.hardOverrideMaxValue)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'hardOverrideMaxValue',
            value: action.hardOverrideMaxValue
          }));
        }
        if (action.authLinkValue) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'linkValue',
            value: action.authLinkValue
          }));
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'linkType',
            value: 'AUTH'
          }));
        }
        if (isValidValue(action.minAvailability)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'hardOverrideMinValue',
            value: action.minAvailability
          }));
        }
        if (isValidValue(action.maxAvailability)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'hardOverrideMaxValue',
            value: action.maxAvailability
          }));
        }
        if (action.linkValue) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'linkValue',
            value: action.linkValue
          }));
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'linkType',
            value: 'AVAIL'
          }));
        }
        if (isValidValue(action.maxAvailability) || isValidValue(action.minAvailability)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'hardOverrideType',
            value: 'AVAIL'
          }));
        }
        if (isValidValue(action.hardOverrideMaxValue) || isValidValue(action.hardOverrideMinValue)) {
          actions.push(new StrategyAction({
            action: 'Set',
            field: 'hardOverrideType',
            value: 'AUTH'
          }));
        }
        conditions.push(createStrategyCondition(ALLOCATION_AUTH_AVAIL.CLASS_NAME_FIELD, action.className, 'PRODUCT', '='));
        if (!_.isEmpty(actions)) {
          groups.push({
            actions: actions,
            conditions: conditions,
            level: ALLOCATION_AUTH_AVAIL.LEVEL
          });
        }
      }
    });
    return {
      strategy: {
        groups: groups,
        name: strategy.name,
        description: strategy.description,
        "public": strategy["public"],
        quickRule: strategy.quickRule || false,
        level: ALLOCATION_AUTH_AVAIL.LEVEL,
        basis: strategy.basis,
        type: strategyConstants.PANEL_TYPE.OPTIMIZATION,
        usage: strategy.usage,
        createdBy: strategy.createdBy,
        createdAt: strategy.createdAt,
        createdDate: strategy.createdDate,
        technicalId: strategy.technicalId
      },
      commonConditions: _.filter(strategyConditions, function (condition) {
        return condition.operator;
      })
    };
  }
  function createStrategyCondition(field, value, category, operator) {
    return new StrategyCondition({
      category: category,
      operator: operator,
      field: field,
      leftOperand: value,
      rightOperand: null,
      quantifier: ''
    });
  }
  function isValidValue(value) {
    return !_.isNil(value) && value !== '';
  }
  return {
    transform: transform
  };
};
ModelToPayloadTransformerServiceAAA.$inject = ['StrategyActionFactory', 'StrategyConditionFactory', 'StrategyConstants'];
module.exports = ModelToPayloadTransformerServiceAAA;